"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icon_1 = __importDefault(require("./icon"));
class FixedAttributionIcon {
    constructor(attributionLink) {
        this.attributionLink = attributionLink;
        this.shouldHandleSize = true;
        this.shouldHandlePositioning = true;
        //TODO: set styles type to object
        this.setElementStyles = (styles) => {
            for (let key in styles) {
                //   container.style.setProperty(key, styles[key]);
                this.domElement.style[key] = styles[key];
            }
        };
        this.setStyles = this.setElementStyles;
        this.setSize = (width, height) => {
            this.domElement.style.width = `${width}px`;
            this.domElement.style.height = `${height}px`;
        };
        this.setAttributionLink = (attributionLink) => {
            this.attributionLinkElement.href = attributionLink;
            // container.appendChild(link);
        };
        this.handleResize = () => {
            if (this.shouldHandlePositioning) {
                this.handlePositioning();
            }
            if (this.shouldHandleSize) {
                this.handleSize();
            }
        };
        this.createDomElement();
        this.addToDom();
        this.handleResize();
        this.addResizeListener();
    }
    createDomElement() {
        const container = document.createElement("div");
        const styles = {
            width: "50px",
            height: "50px",
            backgroundColor: "white",
            zIndex: "100",
            boxSizing: "content-box",
            padding: "2px",
            position: "fixed",
            borderRadius: "100%",
            bottom: "30px",
            right: "30px",
        };
        this.createAttributionElement();
        container.appendChild(this.attributionLinkElement);
        this.setIcon(icon_1.default, true);
        this.domElement = container;
        this.domElement.title = "Attribution";
        this.setElementStyles(styles);
    }
    //   TODO: make public
    setIcon(icon, addWrapper = false) {
        this.attributionLinkElement.innerHTML = "";
        if (addWrapper) {
            const container = document.createElement("div");
            container.style.width = "100%";
            container.style.height = "100%";
            container.appendChild(icon);
            this.attributionLinkElement.appendChild(container);
        }
        else {
            this.attributionLinkElement.appendChild(icon);
        }
    }
    createAttributionElement() {
        const link = document.createElement("a");
        if (this.attributionLink) {
            link.href = this.attributionLink;
        }
        this.attributionLinkElement = link;
    }
    addToDom() {
        document.body.appendChild(this.domElement);
    }
    removeFromDom() {
        document.body.removeChild(this.domElement);
    }
    removeResizeListener() {
        window.removeEventListener("resize", this.handleResize);
    }
    addResizeListener() {
        window.addEventListener("resize", this.handleResize);
    }
    handleSize() {
        if (innerWidth > 1200) {
            this.setSize(50, 50);
        }
        else if (innerWidth > 900) {
            this.setSize(40, 40);
        }
        else if (innerWidth > 600) {
            this.setSize(30, 30);
        }
        else {
            this.setSize(25, 25);
        }
    }
    /** Handle bottom and right fixed position on resize */
    handlePositioning() {
        let bottomRight = [30, 30];
        if (innerWidth > 1200) {
        }
        else if (innerWidth > 900) {
            bottomRight = [25, 25];
        }
        else if (innerWidth > 600) {
            bottomRight = [20, 20];
        }
        else {
            bottomRight = [15, 15];
        }
        this.setElementStyles({
            bottom: `${bottomRight[0]}px`,
            right: `${bottomRight[1]}px`,
        });
    }
}
exports.default = FixedAttributionIcon;
